// src/lib/socketClient.ts
import { io, Socket } from "socket.io-client";
import { backendURL } from "../config";
import { SocketEvents } from "../enums/SocketEvents";

let socket: Socket | null = null;
//to ensure we have a single socket instance across the app
//this is important for performance and to avoid multiple connections
export const getSocket = (): Socket => {
  if (!socket) {
    socket = io(backendURL, {
      transports: ["websocket"],
    });

    socket.on("connect", () => {
      console.log("✅ Global socket connected:", socket?.id);
    });

    socket.on("disconnect", (reason: any) => {
      console.log("❌ Global socket disconnected:", reason);
    });
  }

  return socket;
};
// Function to setup the socket connection with a username
export const setupSocket = (username: string) => {
  const sock = getSocket();
  sock.emit(SocketEvents.SETUP, username);
};
// Function to send a global notification
export const sendGlobalNotification = (payload: any) => {
  const sock = getSocket();
  if (sock.connected) {
    console.log("📤 [GLOBAL] Sending notification:", payload);
    sock.emit(SocketEvents.NOTIFY, payload);
  } else {
    console.warn("⚠️ [GLOBAL] Socket not connected. Notification not sent.");
  }
};
